// extracted by mini-css-extract-plugin
module.exports = {"img-text-card-box":"e9","imgTextCardBox":"e9","text-box":"e-","textBox":"e-","remark-val":"e_","remarkVal":"e_"};